import type { EntityDto } from '@app/api/dtos'
import type { LntTransferItem } from '@app/components/base/Transfer/types'

export const getTransferItemsFromEntities = (entityResponse?: EntityDto[] | null): LntTransferItem[] => {
  return (
    entityResponse?.map(({ id, name }) => ({
      key: id,
      title: name,
      description: name
    })) ?? []
  )
}
